// eslint-disable-next-line jira/restricted/react
import React, { PureComponent, type ReactNode } from 'react';
import Breadcrumb from '@atlassian/jira-breadcrumbs/src/breadcrumb';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl';
import commonMessages from '../i18n/messages';

type Props = {
	children: ReactNode;
	projectKey: string;
	baseUrl: string;
	intl: IntlShape;
};
// eslint-disable-next-line jira/react/no-class-components
export default class View extends PureComponent<Props> {
	renderKnowledgeBaseBreadcrumb() {
		const {
			children,
			baseUrl,
			projectKey,
			intl: { formatMessage },
		} = this.props;
		return (
			<Breadcrumb
				breadcrumb={{
					href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/knowledge`,
					text: formatMessage(commonMessages.knowledgeBase),
					type: 'jsd-knowledge-base',
				}}
			>
				{children}
			</Breadcrumb>
		);
	}

	render() {
		return this.renderKnowledgeBaseBreadcrumb();
	}
}
